import { cn } from '../lib/cn.ts';
import { TONE_CLASS, TONE_LABEL } from '../lib/status.ts';
import type { StatusTone, Tone } from '../lib/status.ts';

export interface StatusDotProps {
  tone: Tone;
  /**
   * @deprecated Ignored. The dot never pulses (docs/design-system/language/motion.md: no colour
   * pulses, no rings around dots). Show work in progress with the working status icon and label.
   */
  pulse?: boolean;
  size?: 'xs' | 'sm' | 'md';
  /** Screen-reader label. Defaults to the tone's human label; pass '' when text beside it already says it. */
  label?: string;
  className?: string;
}

const SIZE = { xs: 'size-1.5', sm: 'size-2', md: 'size-2.5' };

/**
 * A static coloured status dot. Offline and ended render hollow, so status never relies on
 * colour alone. It does not animate: a dot that beats pulls the eye in a room of twenty agents.
 */
export function StatusDot({ tone, size = 'sm', label, className }: StatusDotProps) {
  const hollow = tone === 'offline' || tone === 'ended';
  const aria = label ?? (tone in TONE_LABEL ? TONE_LABEL[tone as StatusTone] : undefined);
  const c = TONE_CLASS[tone];
  return (
    <span
      data-status-dot={tone}
      className={cn('relative inline-flex shrink-0 rounded-full', SIZE[size], hollow ? cn('border-[1.5px] bg-transparent', c.border) : c.bg, className)}
      role={aria ? 'img' : undefined}
      aria-label={aria || undefined}
      aria-hidden={aria ? undefined : true}
    />
  );
}
